import ForgotLogin from './ForgotLogin'

export default ForgotLogin
